import { Sticker } from '../constants/Sticker';

const stickerThumb = (stickerId) => `http:${Sticker.baseurl}/${stickerId}.png`;

export default stickerThumb;
